import { render } from "./DonorScholarship.vue?vue&type=template&id=6361ec14"
import script from "./DonorScholarship.vue?vue&type=script&lang=js"
export * from "./DonorScholarship.vue?vue&type=script&lang=js"
script.render = render

export default script